import Action from '../../Action';
// import './styles/ModalDeleteUSer.css'
import { useEffect, useState } from 'react';
import LoadSimple from '../../LoadSimple';
import { capitalizeFirstLetter } from '../../../utils/utils';
// import './styles/ModalAddHost.css'
import { useFetch } from '../../../hooks/useFetch';
import { lang } from '../../generales/traduction';
import Search from '../../generales/Search';
import Paginador from '../../generales/Paginador';
import SelectorAdmin from '../../SelectorAdmin';
import ModalLinKDeped from './ModalLinKDeped';
import Modal from 'react-modal';
import ModalDeleteCis from "./ModalDeleteCis";
const hostListModalSyncStyles = {
  content: {
    top: "50%",
    left: "50%",
    background: "#ffffff !important",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    width: "70%",
    height: "90%",
    padding: "20px",
  },
};
const deleteCisModalStyles = {
  content: {
    top: "50%",
    left: "50%",
    background: "#ffffff !important",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    width: "40%",
    height: "30%",
    padding: "20px",
  },
};
const ModalCIsDepend =({cisSelected,editActive,event,languaje,search_problems,appSelected,server,mode,setPoolRows,poolObjectRows,setPoolObjectRows,poolRows,handleShowPopup,closeAddHostModal})=>{
  // console.log(poolObjectRows)
  // console.log(poolRows)
  const [hosts,setHosts]=useState({
    data: [],
    loading: true,
    error: null,
  })
  const [dataEvent,setDataEvent]=useState({
    data: [],
    loading: false,
    error: null,
  })
  const [responseAction,setResponseAction]=useState({
    data: [],
    loading: false,
    error: null,
  })
  const [loading,setLoading]=useState(false)
  const [cisSelectedAux, setCisSelectedAux] = useState([]);
  const [hostsListSyncModalOpen, setHostsListSyncModalOpen] =useState(false);
  const [poolRows2,setPoolRows2]=useState([]);
  // console.log(loading)
  // console.log(poolObjectRows)
  // console.log(poolRows)
  function openHostsListSyncModal() {
    //  setCisSelectedAux(elemento);
      setHostsListSyncModalOpen(true);
    }

  function closHostsListSyncModal() {
    
    setHostsListSyncModalOpen(false);
  }
  const type_list=useFetch('cassia/events_correlations/types','','','GET',server)
  const [ManttoData,setManttoData]=useState({
   name: "",
   type: "",
   eventids: []
 })
  const [ManttoDataAux,setManttoDataAux]=useState({
    name: "",
    type: "",
    eventids: []
  })
  const [disable,setDisable]=useState(true)
  useEffect(() => {
   if(editActive){
     search_event()
   }
     buscar_cis();
   }, []);
  useEffect(()=>{
    if(ManttoData.name=="" || ManttoData.type=="" || poolRows.length==0){
      setDisable(true)
    }else{
      setDisable(false)
    }
    },[ManttoData,poolRows])


  const search_event = () => {
    setDataEvent({
      data: hosts.data,
      loading: true,
      error: hosts.error,
    });
  
    const fetchDataPost = async () => {
      try {
        const response = await fetch(
          server.url +
            "/api/v1/cassia/cis_v2/relations/"+cisSelected.id,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              accept: "application/json",
              Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            },
          }
        );
        // console.log(response);
        if (response.ok) {
          const data1 = await response.json();

          setDataEvent({
            data: data1.data,
            loading: false,
            error: hosts.error,
          });
          const [antes, despues] = data1.data.message.split(":").map(part => part.trim());
          // const antesLimpio = antes.replace(/\(\d+\)/, "").trim();
          const antesLimpio = antes.replace(/\([-+]?\d+\)/, "").trim();
          setManttoData({
            name: despues,
            type: antesLimpio,
            eventids: data1.data.events_correlated
          })
          setManttoDataAux({
            name: despues,
            type: antesLimpio,
            eventids: data1.data.events_correlated
          })
          setPoolObjectRows(data1.data.events_correlated)
          setPoolRows(data1.data.events_correlated.map(item => item.cassia_arch_traffic_events_id))
          // setLoading(false)
          // console.log(type_list.data.data.find(e => e.name == ManttoData.type).id)
          // setCreateCisModalOpen(true)
        } else {
          const data1 = await response.json();
          throw new Error("Error en la solicitud");
        }
      } catch (error) {
        console.error(error);
      }
    };

    fetchDataPost();
  };
  const buscar_cis = () => {
    setHosts({
      data: hosts.data,
      loading: true,
      error: hosts.error,
    });
  
    const fetchDataPost = async () => {
      try {
        const response = await fetch(
          server.url +
            "/api/v1/cassia/cis_v2/relations/"+cisSelected.id,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              accept: "application/json",
              Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            },
          }
        );
        if (response.ok) {
          const data1 = await response.json();

          setHosts({
            data: data1.data,
            loading: false,
            error: hosts.error,
          });
          // setLoading(false)
          // setCreateCisModalOpen(true)
        } else {
          const data1 = await response.json();
          throw new Error("Error en la solicitud");
        }
      } catch (error) {
        console.error(error);
      }
    };

    fetchDataPost();
  };

  const registrar = () => {
    setResponseAction({
      data: responseAction.data,
      loading: true,
      error: responseAction.error,
    });

    const data={
      name: ManttoData.name,
      type: ManttoData.type,
      eventids:poolRows
    }
    // console.log(data)
    const url=(editActive)?event.eventid:''
    // let url=(appSelected.software_type_id==1)?'install_software_serveral_hosts':'install_printer_several_hosts'
    const fetchDataPost = async () => {
      try {
        const response = await fetch(
          server.url +
            "/api/v1/cassia/events_correlations/"+url,
          {
            method: (editActive)?"PUT":"POST",
            headers: {
              "Content-Type": "application/json",
              accept: "application/json",
              Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            },
            body:JSON.stringify(data)
          }
        );
        if (response.ok) {
          const data1 = await response.json();

          setResponseAction({
            data: data1,
            loading: false,
            error: responseAction.error,
          });
          setPoolObjectRows([])
          setPoolRows([])
          handleShowPopup('Completado!!!','',data1.message, true)
          closeAddHostModal()
          search_problems()
          // setLoading(false)
          // setCreateCisModalOpen(true)
        } else {
          const data1 = await response.json();
          setResponseAction({
            data: responseAction.data,
            loading: false,
            error: responseAction.error,
          });
          handleShowPopup('Error!!!',capitalizeFirstLetter(lang[languaje]['errorActionComplet']),data1.detail, false)
          throw new Error("Error en la solicitud");
        }
      } catch (error) {
        console.error(error);
      }
    };

    fetchDataPost();
  };
  const [allSelected, setAllSelected] = useState(false);
  const [hostSelected,setHostSelected]=useState([])
  // const [hostSelected,setHostSelected]=useState(hosts.filter(item => poolRows.includes(item.hostid)))
  const [contRowsSelected,setContRowSelected]=useState(0)
  const [searchResults, setSearchResults] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [limitList, setLimitList] = useState(50);
  const [pageActual, setPageActual] = useState(1);
  const [searchResult, setSearchResult] = useState(null);
  var dataList = searchTerm === "" ? hosts.data : searchResults;
  // console.log(dataList)
  const startLimit = limitList * pageActual - limitList;
  const pages = parseInt(dataList.length / limitList) + 1;
  const [searchResults2, setSearchResults2] = useState([]);
  const [searchTerm2, setSearchTerm2] = useState("");
  const [limitList2, setLimitList2] = useState(50);
  const [pageActual2, setPageActual2] = useState(1);
  const [searchResult2, setSearchResult2] = useState(null);
  var dataList2 = []
  // console.log(dataList2)
  const startLimit2 = limitList2 * pageActual2 - limitList2;
  const pages2 = parseInt(dataList2.length / limitList2) + 1;
  const handleSelectAll = () => {
    // console.log(hosts)
      if (allSelected) {
        // Si ya está todo seleccionado, deselecciona todo
        setPoolRows([]);
        setPoolObjectRows([])
      } else {
        setPoolRows(hosts.data.map(item => item.cassia_arch_traffic_events_id))
        setPoolObjectRows(hosts.data)
      }
      setAllSelected(!allSelected); // Alterna el estado de seleccionar todo
    };
  const handleSearch = (query) => {
    setSearchResult(`Resultados para: ${query}`);
  };
  const handleSelectChange = (e) => {
    setPageActual(1)
    setLimitList(e.target.value);setPageActual(1);
  };
  const handleSelectChange2 = (e) => {
    setPageActual2(1)
    setLimitList2(e.target.value);setPageActual2(1);
  };
  const rowSelected = (elemento) => {
    if (allSelected) {
      setAllSelected(false)
    }

    setPoolRows((prevRows) => {
      // Busca si el hostid ya existe en el array
      // console.log(p)/
      const exists = (elemento.eventid==undefined)?prevRows.includes(elemento.cassia_arch_traffic_events_id):prevRows.includes(elemento.eventid);
      // Si existe, filtra para eliminarlo, si no existe, lo agrega
      if (exists) {
        return (elemento.eventid==undefined)?prevRows.filter(cassia_arch_traffic_events_id => cassia_arch_traffic_events_id !== elemento.cassia_arch_traffic_events_id):prevRows.filter(eventid => eventid !== elemento.eventid);
      } else {
        return [...prevRows, (elemento.eventid==undefined)?elemento.cassia_arch_traffic_events_id:elemento.eventid];
      }
    });
    setPoolObjectRows((prevRows) => {
      const getId = (obj) => obj?.cassia_arch_traffic_events_id ?? obj?.eventid;
    
      const newId = getId(elemento);
    
      const exists = prevRows.some(evento => getId(evento) === newId);
    
      if (exists) {
        return prevRows.filter(evento => getId(evento) !== newId);
      } else {
        return [...prevRows, elemento];
      }
    });
    // setPoolObjectRows((prevRows) => {
    //   // Busca si el hostid ya existe en el array

    //   const exists = prevRows.some(evento => evento.cassia_arch_traffic_events_id === elemento.cassia_arch_traffic_events_id);
    //   // Si existe, filtra para eliminarlo, si no existe, lo agrega
    //   if (exists) {
    //     return prevRows.filter(evento => evento.cassia_arch_traffic_events_id !== elemento.cassia_arch_traffic_events_id);
    //   } else {
    //     return [...prevRows, elemento];

    //   }
    // });
    setHostSelected((prevRows) => {
        // Busca si el hostid ya existe en el array de objetos
        const exists = prevRows.some(item => item.hostid === elemento.hostid);
        
        // Si existe, filtra para eliminar el objeto, si no existe, lo agrega
        if (exists) {
          return prevRows.filter(item => item.hostid !== elemento.hostid);
        } else {
          return [...prevRows, elemento];
        }
      });
  };
  const handleChange=(e)=>{
    const {name,value}=e.target

    setManttoData((prevState)=>{
        return {
            ...prevState,
            [name]:value
        }
        
    })
  }
  const changeOption=(option,index)=>{
    setManttoData((prevState)=>{
        return {
            ...prevState,
            ['type']:option.label
        }
        
    })
  }
  const [deleteCisModalOpen, setdeleteCisModalOpen] = useState(false);
  const [userSelected, setUserSelected] = useState({});
  function openDeleteUserModal() {
setdeleteCisModalOpen(true);
}
  function closDeleteCisModal() {
    setdeleteCisModalOpen(false);
  }
  const handledeleteUserClick = (data) => {
openDeleteUserModal();
setUserSelected(data);
// Realiza las acciones deseadas al hacer clic en el marcador
};
  const {name,type}=ManttoData;
  return (
    <>
      <div className="modal-GS-content">
      <div className='card-modal-gs modal-verificate'>
              
              {
                <>
                {
              (dataEvent.loading || type_list.loading)?<div className='head-card-modal-gs' style={{height:'95%'}}>
                <LoadSimple></LoadSimple>
              </div>:
              <>
              
              <div className='content-card-modal-gs' style={{overflowY: 'scroll',scrollbarWidth: 'thin',height:'100%'}}>
                  <div className='half-content-card-modal-gs' style={{width:'100%'} }>
                  <>
 <div className='head-cis'>
  <div className='title-cis'>
              <Search
                  searchResults={searchResults}
                  setSearchResults={setSearchResults}
                  searchTerm={searchTerm}
                  setSearchTerm={setSearchTerm}
                  onSearch={handleSearch}
                  dataObject={hosts.data}
                  searchResult={searchResult}
                  setSearchResult={setSearchResult}
                  languaje={languaje}
                />
       
       <div className="cont-buttons-panel" style={{width:'15%'}}>
                
                  <Action
                  disabled={false}
                  origen="Azul"
                  titulo={"+ Gestionar Dependencias"}
                  action={()=>openHostsListSyncModal()}
                />
                
               
              </div>
             
           
              </div>
              
          </div>
          <div className='cont-cis'>
          <>
    <div className="main-panel-cis">
    <div className="compact-content-portafolio">
    <div className={"content-portafolio-head"+mode}>
      {
      // (contRowsSelected!=0)?
      
        // :''
            }
            </div>
      <div className="content-portafolio">
        <div className="cont-portafolio-table">
          <div className="content-card-portafolio" id="content">
           
          <div className="cont-table-portafolio">
    <div className={"head-table-portafolio"+mode}>
    <div className="compact-head-table-portafolio">
    
      {/* <div className="field-head-table-mantenimiento field-small"> ID</div> */}
      <div className="field-head-table-mantenimiento field-medium" style={{width:'20%'}}>{'CI-ID'}</div>
      <div className="field-head-table-mantenimiento field-medium" style={{width:'20%'}}>{'Nombre'}</div>
      <div className="field-head-table-mantenimiento field-larger" style={{width:'20%'}} >{'IP'} </div>
      <div className="field-head-table-mantenimiento field-larger" style={{width:'20%'}} >{'Zona'} </div>
      <div className="field-head-table-mantenimiento field-larger" style={{width:'20%'}} >{'Acciones'} </div>
     
      </div>
    </div>
    <div className="body-table-portafolio">
    {(hosts.loading)?<div style={{display:'flex',justifyContent:'center',alignItems:'center',width:'100%',height:'100%'}}><LoadSimple/></div>:
    <>
    <div className="cont-row-user-list">
      {(
        // dataList
        //   .slice(startLimit, parseInt(pageActual) * parseInt(limitList))
        //  hosts.data.data.map((elemento, indice) => (
          (dataList
          .slice(startLimit, parseInt(pageActual) * parseInt(limitList)).map((elemento, indice) => (
            <div
              className={"row-table-portafolio"+mode}
              key={indice}
               title={`Status: ${elemento.status ?? elemento.Estatus}`}
              // style={{background:((elemento.softwarestatus!=null)?'var(--border-table-color)':''),color:(elemento.status=='RESOLVED')?'var(--green)':'red'}}
            >
               
            
              <div className="field-body-table-mantenimiento field-larger" style={{width:'20%'}}>
                {elemento.folio}
              </div>
              <div className="field-body-table-mantenimiento field-medium" style={{width:'20%',alignItems:'center'}}>
                {elemento.name}
              </div>
              <div className="field-body-table-mantenimiento field-medium" style={{width:'20%'}}>
                {elemento.ip}
              </div>
             <div className="field-body-table-mantenimiento field-medium" style={{width:'20%'}}>
                {elemento.location}
              </div>
               <div className="field-body-table-mantenimiento field-medium" style={{width:'20%'}}>
              {/* <div  style={{width:'33%'}}>
                  <img
                    className="img-field-acciones"
                    src="/iconos/delete.png"
                    title="Eliminar"
                    name="Eliminar"
                    ci_id={elemento.ci_id}
                    onClick={(e) => {
                      e.stopPropagation();
                      handledeleteUserClick(elemento);
                    }}
                    style={{width:'40%'}}
                  />
                </div> */}
              </div>
            </div>
          )))
        
      )}
      { (dataList.length == 0 ) ? (
        <div className="no-results">{capitalizeFirstLetter(lang[languaje]['sinResultados'])}.</div>
      ) : (
        ""
      )}
    </div>
    
  </>
  }
    </div>
  </div>
          </div>
        </div>

        </div>
        <div className={"content-portafolio-footer"+mode}>
        <div className="cont-display-paginador" style={{position: 'absolute',left: '0%',justifyContent: 'start'}}>
          
          {/* <div className={"cont-half-display-paginador"+mode}>
          <p style={{  textAlign: "center" }}>
                          &nbsp;
                          {(contRowsSelected!=0)?"("+contRowsSelected+")  "+capitalizeFirstLetter(lang[languaje]['registosSeleccionados']):''}
                    </p> 
                
          </div> */}
        </div>  
        <div className="cont-display-paginador" style={{width:'60%'}}>
                  <Paginador  pages={pages}
                              pageActual={pageActual}
                              setPageActual={setPageActual}
                              mode={mode}></Paginador>
        </div>
        <div className="cont-display-paginador" style={{width:'50%'}}>
          <div className={"cont-half-display-paginador"+mode}>
                    
          <div>
    <label htmlFor="selector">{capitalizeFirstLetter(lang[languaje]['filasPagina'])}: </label>
    <select id="selector" value={limitList} className="pageSelector" onChange={handleSelectChange}>
      <option value={10}>10</option>
      <option value={50} >50</option>
      <option value={100}>100</option>
      <option value={500}>500</option>
      <option value={1000}>1000</option>
    </select>

    
  </div>
          </div>
          <div className={"cont-half-display-paginador"+mode} >
          <p style={{  textAlign: "center" ,fontSize:'var(--font-size-xSmall) !important'}}>
                          &nbsp;
                          {"(" +
                      (startLimit + 1) +
                      " - " +
                      (dataList.length >  parseInt(pageActual ) * parseInt(limitList)
                        ?  parseInt(pageActual ) * parseInt(limitList)
                        : dataList.length) +
                      ")  "+lang[languaje]['de']+" " +
                      dataList.length +
                      " "+lang[languaje]['resultados']}
                    </p>
                
          </div>
        </div>  
                  
      </div>
      </div>
    </div>
    
  </>
              
          </div>
 </>
    
                  </div>
                  
                  
              </div>
              <div className="cont-buttons-panel" style={{width:'50%', display:'flex',top:'unset',height:'10%'} }>
               {
                
                (responseAction.loading)?<LoadSimple></LoadSimple>:
                 
                <>
                <Action
                disabled={disable}
                origen="Azul"
                titulo={(editActive)?capitalizeFirstLetter(lang[languaje]['editar']):capitalizeFirstLetter(lang[languaje]['crear'])}
                action={registrar}
              />
              
                </>
                
               }
                  
                
                  <Action
              disabled={false}
              origen="Cancelar"
              titulo={""+capitalizeFirstLetter(lang[languaje]['cancelar'])}
              action={closeAddHostModal}
            />
              </div>
              
              
              </>
              }
              </>
              }
              
          </div>
          </div>
      <Modal
  isOpen={hostsListSyncModalOpen}
  // isOpen={true}
  // onAfterOpen={afterOpenExeption}
  onRequestClose={closHostsListSyncModal}
  style={hostListModalSyncStyles}
  contentLabel="Example Modal2"
  // shouldCloseOnOverlayClick={false}
  >
    <ModalLinKDeped   buscar_dep={ buscar_cis} poolRows={poolRows2} server={server} handleShowPopup={handleShowPopup}  cisSelectRow={cisSelected} setPoolRows={setPoolRows2} languaje={languaje}  mode={mode} closeAddHostModal={closHostsListSyncModal}  ></ModalLinKDeped>
</Modal>
      <Modal
          isOpen={deleteCisModalOpen}
          // isOpen={true}
          // onAfterOpen={afterOpenExeption}
          onRequestClose={closDeleteCisModal}
          style={deleteCisModalStyles}
          contentLabel="Example Modal2"
          // shouldCloseOnOverlayClick={false}
        >
          <ModalDeleteCis
            server={server}
            // setRegisterIsValid={setRegisterIsValid}
            // setData={setData}
            setLoading={setLoading}
            // setError={setError}
            cis={userSelected}
            languaje={languaje}
            closDeleteCisModal={closDeleteCisModal}
            handleShowPopup={handleShowPopup}
          ></ModalDeleteCis>
        </Modal>
    </>
  );
}

export default ModalCIsDepend